export { default as CorporateSealSlot } from './CorporateSealSlot';
